"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputFile = void 0;
var _react = _interopRequireWildcard(require("react"));
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _constants = require("./constants");
var _helpers = require("./helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var noop = function noop() {};
var InputFilePure = function InputFilePure(_ref) {
  var trigger = _ref.trigger,
    _ref$extensions = _ref.extensions,
    extensions = _ref$extensions === void 0 ? _constants.DEFAULT_FILE_EXTENSIONS : _ref$extensions,
    _ref$multiple = _ref.multiple,
    multiple = _ref$multiple === void 0 ? false : _ref$multiple,
    _ref$maxFileSizeInByt = _ref.maxFileSizeInBytes,
    maxFileSizeInBytes = _ref$maxFileSizeInByt === void 0 ? 15728640 : _ref$maxFileSizeInByt,
    _ref$onError = _ref.onError,
    onError = _ref$onError === void 0 ? noop : _ref$onError,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? noop : _ref$onChange;
  var inputRef = (0, _react.useRef)(null);
  var onLoadFile = (0, _react.useCallback)(function () {
    inputRef.current.value = null;
    inputRef.current.click();
  }, []);
  var _useTranslation = (0, _reactI18next.useTranslation)('VALIDATION_ERRORS'),
    t = _useTranslation.t;
  var handleChange = function handleChange(_ref2) {
    var target = _ref2.target;
    var files = target.files;
    if (R.isEmpty(files)) {
      return;
    }
    var isValidFiles = (0, _helpers.getIsValidFiles)(files, extensions, maxFileSizeInBytes);
    if (isValidFiles) {
      onChange(files);
    } else {
      onError({
        type: _constants.FORBIDDEN_FILE_ERROR,
        message: t('INVALID_FILE', {
          maxFileSize: (0, _helpers.convertBytes2Mb)(maxFileSizeInBytes),
          allowExtensions: (0, _helpers.stringifyExtensions)(extensions)
        })
      });
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("input", {
    multiple: multiple,
    ref: inputRef,
    style: {
      display: 'none'
    },
    type: "file",
    onChange: handleChange
  }), _react.default.cloneElement(trigger, {
    onClick: onLoadFile
  }));
};
InputFilePure.propTypes = {
  trigger: _propTypes.default.node,
  extensions: _propTypes.default.array,
  multiple: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onError: _propTypes.default.func
};
var InputFile = exports.InputFile = (0, _react.memo)(InputFilePure);